import PawModel from './PawModel';

class App extends PawModel {
  static apiType = 'apps';

  name?: string;
}

export default App;